/**
 * @generated SignedSource<<7b2c08fbe7ea7683aab14d2cf139dd49>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContributionsGrid_participativeModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionsGridTiles_participativeModule"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionsListFilters_participativeModule"
    }
  ],
  "type": "ParticipativeModule",
  "abstractKey": null
};

node.hash = "8c027b0b76fb3fb5da94c95b64cbd878";

module.exports = node;
